import React from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";

const HeaderMerchangdisingOrder = ({ product }) => {
	const classes = useStyles();
	return (
		<React.Fragment>
			<Grid classes={{ root: classes.border }} style={{ left: -8 }} />
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.header }}>
					<Grid classes={{ root: classes.titleHeader }}>
						{product?.title || ""}
					</Grid>
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.border }} style={{ right: -8 }} />
		</React.Fragment>
	);
};

export default HeaderMerchangdisingOrder;
